import React from 'react';
import PropTypes from 'prop-types';
import { FormSpy } from 'react-final-form';
import HeaderAndError from '../../../commons/form-fields/HeaderAndError';
import GenericToggleButtonGroupField from '../../../commons/form-fields/GenericToggleButtonGroupField';
import { trueFalseOptions } from '../../OnboardingConstants';
import GenericTextAreaInputField from '../../../commons/form-fields/GenericTextAreaInputField';

class AreaOfExpertiseInner extends React.Component {
    render() {
        const isLicensedToPractise =
            this.props.values.info?.areaOfExpertise?.isLicensedToPractice;
        return (
            <div className="max-w-4xl mx-auto bg-white px-6 py-1 md:mt-3 md:mb-6 rounded shadow-md text-sm">
                <HeaderAndError label="Area Of Expertise" />
                <GenericTextAreaInputField
                    name={'info.areaOfExpertise.areaOfExpertiseDesc'}
                    label={
                        'Please describe any areas of expertise or substantial experience that you feel competent ' +
                        'to consult on as an expert and the basis of such expertise.'
                    }
                />
                <GenericToggleButtonGroupField
                    name={'info.areaOfExpertise.isLicensedToPractice'}
                    inlineLabel={
                        'Are you licensed to practice and/or certified in a particular field, profession or discipline?'
                    }
                    options={trueFalseOptions}
                    required
                />
                {isLicensedToPractise && (
                    <GenericTextAreaInputField
                        name={'info.areaOfExpertise.licensedToPracticeDesc'}
                        label={
                            'Please provide a brief explanation of your answer.'
                        }
                        required
                        clearOnUnmount
                    />
                )}
            </div>
        );
    }
}

AreaOfExpertiseInner.propTypes = {
    values: PropTypes.any,
};

const AreaOfExpertiseInfoFormSection = (props) => (
    <FormSpy {...props} component={AreaOfExpertiseInner} />
);

export { AreaOfExpertiseInfoFormSection };
